// components/QuantityCounter.jsx

import {
  CounterWrapper,
  CounterArrow,
  CounterValue,
} from "../styles/product";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const QuantityCounter = ({
  value,
  onChange,
  productName = "",
}) => {
  const numericValue = Number(value) || 0;

  const handleIncrease = () => {
    onChange(numericValue + 1);
  };

  const handleDecrease = () => {
    if (numericValue <= 0) {
      return;
    }

    onChange(numericValue - 1);
  };

  const handleInputChange = (event) => {
    const rawValue = event.target.value;

    if (rawValue === "") {
      onChange(0);
      return;
    }

    let newValue = Number(rawValue);

    if (Number.isNaN(newValue)) {
      return;
    }

    if (newValue < 0) {
      newValue = 0;
    }

    onChange(newValue);
  };

  const productDescription = productName
    ? ` של ${productName}`
    : "";

  return (
    <CounterWrapper
      role="group"
      aria-label={`בחירת כמות${productDescription}`}
    >
      <CounterArrow
        type="button"
        onClick={handleIncrease}
        aria-label={`הגדלת כמות${productDescription}. הכמות הנוכחית היא ${numericValue}`}
        title="הגדלת כמות"
      >
        <KeyboardArrowUpIcon
          fontSize="small"
          aria-hidden="true"
          focusable="false"
        />
      </CounterArrow>

      <CounterValue
        type="number"
        value={numericValue}
        onChange={handleInputChange}
        min={0}
        inputMode="numeric"
        aria-label={`כמות${productDescription}`}
        aria-valuemin={0}
        aria-valuenow={numericValue}
      />

      <CounterArrow
        type="button"
        onClick={handleDecrease}
        disabled={numericValue <= 0}
        aria-label={`הפחתת כמות${productDescription}. הכמות הנוכחית היא ${numericValue}`}
        title="הפחתת כמות"
      >
        <KeyboardArrowDownIcon
          fontSize="small"
          aria-hidden="true"
          focusable="false"
        />
      </CounterArrow>

      <span
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: "absolute",
          width: "1px",
          height: "1px",
          padding: 0,
          margin: "-1px",
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      >
        הכמות שנבחרה היא {numericValue}
      </span>
    </CounterWrapper>
  );
};

export default QuantityCounter;